import {createContext} from 'react';

const ActionListContext = createContext();
const ReactionListContext = createContext();

export {ActionListContext, ReactionListContext};
